import React from "react";
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import FeedbackDashboard from "../components/FeedbackDashboard.js";

function AdminPage() {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header Section */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Admin Dashboard
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              View booking feedback and user satisfaction insights
            </p>
          </div>

          {/* Feedback Dashboard */}
          <div className="max-w-6xl mx-auto">
            <FeedbackDashboard />
          </div>

          {/* Additional Admin Tools */}
          <div className="max-w-6xl mx-auto mt-8">
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Quick Actions
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <a
                  href="https://console.firebase.google.com/project/barma-sorig/firestore/data/~2FUTA-feedback"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center p-4 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-lg transition-colors duration-200"
                >
                  <svg className="w-6 h-6 text-blue-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                  <div>
                    <div className="font-medium text-blue-900">View Raw Data</div>
                    <div className="text-sm text-blue-700">Firebase Console</div>
                  </div>
                </a>

                <a
                  href="https://console.firebase.google.com/project/barma-sorig/firestore/data/~2Fbookings"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center p-4 bg-green-50 hover:bg-green-100 border border-green-200 rounded-lg transition-colors duration-200"
                >
                  <svg className="w-6 h-6 text-green-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3a4 4 0 118 0v4m-4 3v6m-1 0h2m-1 0h2m-1 0v3a4 4 0 01-8 0v-3m4 0V7" />
                  </svg>
                  <div>
                    <div className="font-medium text-green-900">View Bookings</div>
                    <div className="text-sm text-green-700">All Bookings Data</div>
                  </div>
                </a>

                <button
                  onClick={() => window.location.reload()}
                  className="flex items-center p-4 bg-purple-50 hover:bg-purple-100 border border-purple-200 rounded-lg transition-colors duration-200"
                >
                  <svg className="w-6 h-6 text-purple-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                  <div>
                    <div className="font-medium text-purple-900">Refresh Data</div>
                    <div className="text-sm text-purple-700">Update Statistics</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AdminPage;